<script lang="ts">
    import {page} from '$app/state';

    const comparisons = [
        {
            name: 'Duolingo',
            route: '/vocabeo-vs-duolingo',
            text: 'Discover how <b>vocabeo</b>\'s focused vocabulary approach compares to Duolingo\'s gamified full-language learning experience. Find out which platform better matches your learning preferences.'
        },
        {
            name: 'Quizlet',
            route: '/vocabeo-vs-quizlet',
            text: 'Compare <b>vocabeo</b>\'s specialized vocabulary features with Quizlet\'s versatile flashcard system. Learn which tool offers the most effective method for your vocabulary building needs.',
        },
        {
            name: 'Anki',
            route: '/vocabeo-vs-anki',
            text: 'Discover how <b>vocabeo</b>\'s structured vocabulary approach compares to Anki\'s highly customizable flashcard system. Find out which tool best supports your language-learning goals.',
        },
        {
            name: 'Clozemaster',
            route: '/vocabeo-vs-clozemaster',
            text: 'Compare <b>vocabeo</b>\'s flexible vocabulary building system with Clozemaster\'s gamified practice approach. Discover which platform offers the most effective sentence-based practice for your language learning journey.',
        },
        // {
        //     name: 'Memrise',
        //     route: '/vocabeo-vs-memrise',
        //  text: '',
        // }
    ]
</script>

<svelte:head>
    <title>Vocabeo vs Duolingo, Quizlet, Anki & Clozemaster – Feature Comparison</title>

    <meta name="description"
          content="Compare vocabeo's specialized vocabulary features with Duolingo, Quizlet, Anki, and Clozemaster. Find the best tool for your language learning needs.">
</svelte:head>

<h1>Best vocabulary learning apps:<br>How vocabeo compares to popular alternatives</h1>
<p class="intro">
    Whether you're a beginner or advanced language learner, choosing the right vocabulary app matters. Discover how
    <b>vocabeo</b>'s features compare to Duolingo, Quizlet, Anki and Clozemaster in our detailed comparison and find out
    which tool best matches your learning style.
</p>

<div class="comparisons">
    {#each comparisons as c, index}
        <div class="comparison {c.name.toLowerCase()}">
            <h2>vocabeo vs {c.name}</h2>
            <p>
                {@html c.text}
            </p>
            <a href="{page.url.pathname + c.route}"
               class="button-primary"
            >
                {index % 2 === 0 ? '» View comparison' : '» Compare now'}
            </a>
        </div>
    {/each}
</div>

<style>
    h1 {
        font-size: 1.6rem;
        text-wrap: balance;
        margin-bottom: var(--space-md);
        line-height: 1.5;
    }

    p.intro {
        margin-bottom: var(--space-lg);
    }

    .comparisons {
        display: grid;
        gap: var(--space-xl);
    }

    .comparison {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    h2 {
        font-size: 1.4rem;
        margin: 0;
    }

    .comparison.duolingo a {
        background: var(--color-Adverb);
    }

    .comparison.quizlet a {
        background: var(--color-Adjective);
    }

    .comparison.clozemaster a {
        background: var(--color-Preposition);
    }
</style>